import { render, staticRenderFns } from "./userdetails.vue?vue&type=template&id=60cb5639&scoped=true&"
import script from "./userdetails.vue?vue&type=script&lang=js&"
export * from "./userdetails.vue?vue&type=script&lang=js&"
import style0 from "./userdetails.vue?vue&type=style&index=0&id=60cb5639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb5639",
  null
  
)

export default component.exports